import ConfigManager from "../../utils/ConfigManager.js";
import "./SettingsDropdown.css";

/**
 * Dropdown de configuration des paramètres de détection
 * Interface utilisateur pour personnaliser les 3 seuils
 */
class SettingsDropdown {
  constructor() {
    this.isOpen = false;
    this.currentValues = ConfigManager.getConfig();
    this.backdropClickHandler = null;
  }

  /**
   * Crée le HTML du dropdown
   */
  render() {
    const defaultConfig = ConfigManager.getDefaultConfig();
    const isCustom = ConfigManager.isCustomConfig();

    return `
      <div class="settings-dropdown-container">
        <div class="settings-backdrop"></div>
        
        <div class="settings-panel">
          <div class="settings-header">
            <h3 class="settings-title">Configuration</h3>
            ${isCustom ? '<span class="settings-badge">Personnalisé</span>' : ""}
          </div>

          <div class="settings-body">
            <!-- Seuil Moyenne connecteurs -->
            <div class="settings-field">
              <label class="settings-label">
                Seuil Moyenne connecteurs (dB)
                <span class="settings-sublabel">Tolérance pour la comparaison des moyennes de connecteurs</span>
              </label>
              <input 
                type="number" 
                step="0.01" 
                min="0" 
                max="1"
                class="settings-input" 
                id="input-seuilMoyenneConnecteurs"
                value="${this.currentValues.seuilMoyenneConnecteurs}"
                data-default="${defaultConfig.seuilMoyenneConnecteurs}"
              />
            </div>

            <!-- Seuil Moyenne épissures -->
            <div class="settings-field">
              <label class="settings-label">
                Seuil Moyenne épissures (dB)
                <span class="settings-sublabel">Tolérance pour la comparaison des moyennes d'épissures</span>
              </label>
              <input 
                type="number" 
                step="0.01" 
                min="0" 
                max="1"
                class="settings-input" 
                id="input-seuilMoyenneEpissures"
                value="${this.currentValues.seuilMoyenneEpissures}"
                data-default="${defaultConfig.seuilMoyenneEpissures}"
              />
            </div>

            <!-- Seuil Perte totale -->
            <div class="settings-field">
              <label class="settings-label">
                Seuil Perte totale (dB)
                <span class="settings-sublabel">Tolérance pour la comparaison de la perte totale</span>
              </label>
              <input 
                type="number" 
                step="0.01" 
                min="0" 
                max="2"
                class="settings-input" 
                id="input-seuilPerteTotale"
                value="${this.currentValues.seuilPerteTotale}"
                data-default="${defaultConfig.seuilPerteTotale}"
              />
            </div>
          </div>

          <div class="settings-footer">
            <button 
              class="settings-icon-btn" 
              id="btn-save"
              title="Sauvegarder"
            >
              💾
            </button>
            <button 
              class="settings-icon-btn" 
              id="btn-reset"
              title="Réinitialiser"
            >
              ↻
            </button>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Monte le dropdown dans le DOM
   */
  mount(container) {
    const targetElement = typeof container === "string" ? document.querySelector(container) : container;

    if (!targetElement) {
      throw new Error("Container non trouvé pour SettingsDropdown");
    }

    targetElement.innerHTML = this.render();
    this.attachEventListeners();
  }

  /**
   * Attache les événements
   */
  attachEventListeners() {
    const backdrop = document.querySelector(".settings-backdrop");
    this.backdropClickHandler = () => this.close();
    backdrop.addEventListener("click", this.backdropClickHandler);

    const saveBtn = document.getElementById("btn-save");
    saveBtn.addEventListener("click", () => this.handleSave());

    const resetBtn = document.getElementById("btn-reset");
    resetBtn.addEventListener("click", () => this.handleReset());

    const inputs = document.querySelectorAll(".settings-input");
    inputs.forEach((input) => {
      input.addEventListener("input", (e) => this.validateInput(e.target));
    });
  }

  /**
   * Valide un input en temps réel
   */
  validateInput(input) {
    const value = parseFloat(input.value);
    const min = parseFloat(input.min);
    const max = parseFloat(input.max);

    if (isNaN(value) || value < min || value > max) {
      input.classList.add("input-error");
    } else {
      input.classList.remove("input-error");
    }
  }

  /**
   * Récupère les valeurs des inputs
   */
  getInputValues() {
    return {
      seuilMoyenneConnecteurs: parseFloat(document.getElementById("input-seuilMoyenneConnecteurs").value),
      seuilMoyenneEpissures: parseFloat(document.getElementById("input-seuilMoyenneEpissures").value),
      seuilPerteTotale: parseFloat(document.getElementById("input-seuilPerteTotale").value),
    };
  }

  /**
   * Gère la sauvegarde
   */
  handleSave() {
    const values = this.getInputValues();
    const result = ConfigManager.saveConfig(values);

    if (result.success) {
      this.currentValues = values;
      this.showToast("Configuration sauvegardée", "success");
      this.close();
    } else {
      this.showToast(result.errors.join(", "), "error");
    }
  }

  /**
   * Gère la réinitialisation
   */
  handleReset() {
    ConfigManager.resetConfig();
    this.currentValues = ConfigManager.getDefaultConfig();
    this.showToast("Configuration réinitialisée", "info");
    this.close();
  }

  /**
   * Affiche un toast de notification
   */
  showToast(message, type) {
    console.log(`[${type.toUpperCase()}] ${message}`);
  }

  /**
   * Ferme le dropdown
   */
  close() {
    const container = document.querySelector(".settings-dropdown-container");
    if (container) {
      container.classList.add("closing");
      setTimeout(() => {
        container.remove();
        this.isOpen = false;
      }, 200);
    }
  }

  /**
   * Nettoie les événements
   */
  destroy() {
    const backdrop = document.querySelector(".settings-backdrop");
    if (backdrop && this.backdropClickHandler) {
      backdrop.removeEventListener("click", this.backdropClickHandler);
    }
  }
}

export default SettingsDropdown;
